"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRailgunTransactionWithID = exports.getRailgunTransactionID = void 0;
const circomlibjs_1 = require("circomlibjs");
const bytes_1 = require("../utils/bytes");
const merkletree_types_1 = require("../models/merkletree-types");
const padWithZerosToMax = (array, max) => {
    const padded = [...array];
    while (padded.length < max) {
        padded.push(merkletree_types_1.MERKLE_ZERO_VALUE_BIGINT);
    }
    return padded;
};
const getRailgunTransactionID = (railgunTransaction) => {
    const maxInputs = 13;
    const nullifiersPadded = padWithZerosToMax(railgunTransaction.nullifiers.map((el) => (0, bytes_1.hexToBigInt)(el)), maxInputs);
    const nullifiersHash = (0, circomlibjs_1.poseidon)(nullifiersPadded);
    const maxOutputs = 13;
    const commitmentsPadded = padWithZerosToMax(railgunTransaction.commitments.map((el) => (0, bytes_1.hexToBigInt)(el)), maxOutputs);
    const commitmentsHash = (0, circomlibjs_1.poseidon)(commitmentsPadded);
    const boundParamsHash = (0, bytes_1.hexToBigInt)(railgunTransaction.boundParamsHash);
    const railgunTxid = (0, circomlibjs_1.poseidon)([nullifiersHash, commitmentsHash, boundParamsHash]);
    return railgunTxid;
};
exports.getRailgunTransactionID = getRailgunTransactionID;
const createRailgunTransactionWithID = (railgunTransaction) => {
    const txid = (0, exports.getRailgunTransactionID)(railgunTransaction);
    return {
        ...railgunTransaction,
        hash: (0, bytes_1.nToHex)(txid, bytes_1.ByteLength.UINT_256),
    };
};
exports.createRailgunTransactionWithID = createRailgunTransactionWithID;
